const Copyright = (props) => {
    const { heart } = props;

    var d = new Date();

    return (
        (!heart) ?
            <p>© {d.getFullYear()} Colmeia. Todos os direitos reservados.</p>
            :
            <>
                <p>© {new Date().getFullYear()} Colmeia. Todos os direitos reservados.</p>
            </>
    )
}

export default Copyright;